export const UPDATE_ERRORS = "Setze Errors für Komponenten";
export const UPDATE_GLOBAL_ERROR = "Setzt den globalen Error";
export const UPDATE_ALL_ERRORS = "Setze alle Errors";
export const UPDATE_WARNINGS = "Setze Warning";

export const UPDATE_NOTIFICATIONS = "Setze Notification für Komponent";
